export const state = {
  // product: undefined,
  // products: []
  permission: {},
  permissions: [],
  pagination:''
}
